import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "disabled"]

import { computed } from "vue";

interface Props {
  /** Тип кнопки */
  type?: "button" | "submit" | "reset";
  /** Отключена ли кнопка */
  disabled?: boolean;
  /** Инвертированный вариант (белый фон, черная иконка) */
  inverted?: boolean;
  /** Размер кнопки */
  size?: "sm" | "md" | "lg";
}

interface Emits {
  (e: "click", event: MouseEvent): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    type: { default: "button" },
    disabled: { type: Boolean, default: false },
    inverted: { type: Boolean, default: false },
    size: { default: "md" }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const variantClasses = computed(() => {
  return __props.inverted ? "button--inverted" : "button--default";
});

const sizeClasses = computed(() => {
  return `button--${__props.size}`;
});

const handleClick = (event: MouseEvent) => {
  if (!__props.disabled) {
    emit("click", event);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['button', variantClasses.value, sizeClasses.value]),
    type: __props.type,
    disabled: __props.disabled,
    onClick: handleClick
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})